import { render } from "./LmsAgentChat.vue?vue&type=template&id=576e12d5&scoped=true"
import script from "./LmsAgentChat.vue?vue&type=script&lang=js"
export * from "./LmsAgentChat.vue?vue&type=script&lang=js"

import "./LmsAgentChat.vue?vue&type=style&index=0&id=576e12d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576e12d5"]])

export default __exports__